import React from "react";
import { StyleSheet, View } from "react-native";
import CustomText from "@components/CustomText";
import { meta } from "@constants/cplp";
import Icon from "@assets/svg/CrossCircle";

const DeliveryCodeNotGenerated = () => {
  return (
    <View style={styles.container}>
      <Icon />
      <CustomText variant="subtitle_16" style={styles.text}>
        {meta?.delivery_code_not_created}
      </CustomText>
    </View>
  );
};

const styles = StyleSheet.create({
  container: { minHeight: 300, alignItems: "center", justifyContent: "center" },
  text: { color: "rgba(0, 0, 0, 0.86)", marginTop: 20 },
});

export default DeliveryCodeNotGenerated;
